import { render, staticRenderFns } from "./Detial.vue?vue&type=template&id=375cbbdc&"
import script from "./Detial.vue?vue&type=script&lang=js&"
export * from "./Detial.vue?vue&type=script&lang=js&"
import style0 from "./Detial.vue?vue&type=style&index=0&id=375cbbdc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports